import {Component, EventEmitter, Input, Output} from '@angular/core';

export interface SpinnerButtonListener {
  onComplete();

  onResume();
}

@Component({
  selector: 'app-spinner-button',
  templateUrl: './spinner-button.component.html',
  styleUrls: ['./spinner-button.component.scss']
})
export class SpinnerButtonComponent {
  @Input() disabled: boolean;
  @Input() color?: string;
  @Input() text = 'Save';
  @Input() btnColor = 'primary';
  public loading = false;
  @Output() spinClick: EventEmitter<SpinnerButtonListener> = new EventEmitter<SpinnerButtonListener>();

  onClick(event) {
    event.stopPropagation();
    this.spinClick.emit({
      onResume: () => {
        this.loading = true;
      },
      onComplete: () => {
        this.loading = false;
      }
    });
  }
}
